'use client';
import { FollowUnfollowButton } from '@app/_components/follow-unfollow-button';
import { LoginRequiredModal } from '@app/_components/login-required-modal';
import { UnfollowConfirmModal } from '@app/_components/unfollow-confirm-modal';
import type { Props } from './types';
import { useLocalHooks } from './use-local-hooks';

export const FollowUnfollowButtonContainer = ({
  noOverlay,
  smallRightAligned,
  ...props
}: Props) => {
  const {
    user,
    handleOnClick,
    followState,
    canUnfollow,
    isShowConfirm,
    closeConfirm,
    closeConfirmAndUnfollow,
    isShowLoginRequiredModal,
    closeShowLoginRequiredModal,
    isMe,
  } = useLocalHooks(props);

  if (typeof isMe === 'undefined' || isMe) return null;

  return (
    <>
      <FollowUnfollowButton
        state={followState}
        config={{
          canUnfollow,
          smallRightAligned,
        }}
        onClick={handleOnClick}
      />
      {isShowConfirm && (
        <UnfollowConfirmModal
          open={isShowConfirm}
          user={user}
          onClose={closeConfirm}
          onConfirm={closeConfirmAndUnfollow}
          noOverlay={noOverlay}
        />
      )}
      {isShowLoginRequiredModal && (
        <LoginRequiredModal
          userId={user.id}
          isOpen={isShowLoginRequiredModal}
          onClose={closeShowLoginRequiredModal}
        />
      )}
    </>
  );
};
